import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { FeeInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransferProvider } from '../providers/transfer-provider.service';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface EvaluateFeeUseCaseParams {
    data: FeeInterface;
}

@Injectable()
export class EvaluateFeeUseCase implements UseCaseWithParam<EvaluateFeeUseCaseParams, Observable<Transaction<number>>> {
    constructor(private contractProvider: ContractProvider, private transferProvider: TransferProvider) {}

    bind(params: EvaluateFeeUseCaseParams): Observable<Transaction<number>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.transferProvider.evaluateFee(contract.encryptedCode, params.data),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
